import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-not', 'MathNot', [["path",{"d":"M5 12h14v4"}]]);